import { PaginationJumpItem } from './PaginationJumpItem';

// TODO: in v9, move styled() from PaginationJumpItem.jsx to here
export var StyledPaginationJumpItem = PaginationJumpItem;